import { render, staticRenderFns } from "./MapLayerSwitcherFloating.vue?vue&type=template&id=0addc755&scoped=true"
import script from "./MapLayerSwitcherFloating.vue?vue&type=script&lang=js"
export * from "./MapLayerSwitcherFloating.vue?vue&type=script&lang=js"
import style0 from "./MapLayerSwitcherFloating.vue?vue&type=style&index=0&id=0addc755&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0addc755",
  null
  
)

export default component.exports